import React from 'react';

import Radio from '@material-ui/core/Radio';
import { MobxZodField, MobxZodTypes } from '@monoid-dev/mobx-zod-form';
import { getForm } from '@monoid-dev/mobx-zod-form-react';
import { observer } from 'mobx-react';
import { z } from 'zod';

export type RadioInputProps<T extends MobxZodTypes> = {
  field: MobxZodField<T>;
  value: z.infer<T>;
  disabled?: boolean;
};

export const RadioInput = observer(
  <T extends MobxZodTypes>({ field, value, disabled }: RadioInputProps<T>) => {
    const form = getForm(field);

    const radioProps = form.bindField(field, {
      type: 'radio',
      value,
    });

    return (
      <Radio
        name={radioProps.name}
        id={radioProps.id}
        checked={radioProps.checked}
        onChange={radioProps.onChange}
        disabled={disabled}
        ref={(e) => (field.element = e)}
        color="primary"
        size="small"
      />
    );
  },
);
